export const MOVE_PRODUCTS_BETWEEN_WISHLISTS = /* GraphQL */ `
    mutation moveProductsBetweenWishlists(
        $sourceWishlistUid: ID!
        $destinationWishlistUid: ID!
        $wishlistItems: [WishlistItemMoveInput!]!
    ) {
        moveProductsBetweenWishlists(
            sourceWishlistUid: $sourceWishlistUid
            destinationWishlistUid: $destinationWishlistUid
            wishlistItems: $wishlistItems
        ) {
            destination_wishlist {
                id
                name
            }
        }
    }
`
